<template lang="pug">
  table.table.table_bordered.table_simple(v-if="leaders" style="table-layout: fixed;")
    colgroup
      col(width="52")
    thead
      tr
        th
        th Дистанция
        th Длительность
        th Подъём в гору
    tbody
      tr(v-for="(row, i) in rows")
        td
          div(style="width: 40px; min-width: 40px; height: 40px")
            img(
              :src="require(`@/assets/img/icons/${i + 1}-place-medal.svg`)"
              width="100%"
              :alt="i"
            )
        td
          table.table.table_x-paddings
            tbody
              tr(v-if="row.byDistance")
                td
                  Member(
                    :userId="row.byDistance.id"
                    :name="row.byDistance.fullName"
                    :img="row.byDistance.avatarSmallUrl"
                  )
                td.text-right: span.text-lg {{ row.byDistance.totalDistance }}&nbsp;<span class="text-xs">км</span>
              tr(v-else)
                td(colspan="2").text-center --
        td
          table.table.table_x-paddings
            tbody
              tr(v-if="row.byTime")
                td
                  Member(
                    :userId="row.byTime.id"
                    :name="row.byTime.fullName"
                    :img="row.byTime.avatarSmallUrl"
                  )
                td.text-right: span.text-lg {{ row.byTime.totalTime }}
              tr(v-else)
                td(colspan="2").text-center --
        td
          table.table.table_x-paddings
            tbody
              tr(v-if="row.byHeight")
                td
                  Member(
                    :userId="row.byHeight.id"
                    :name="row.byHeight.fullName"
                    :img="row.byHeight.avatarSmallUrl"
                  )
                td.text-right: span.text-lg {{ row.byHeight.totalHeight }}&nbsp;<span class="text-xs">м</span>
              tr(v-else)
                td(colspan="2").text-center --
</template>

<script>
import Member from '@/components/Member'
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: 'LeadersTable',
  components: {
    Member,
    Skeleton
  },
  props: {
    leaders: Object
  },
  computed: {
    rows () {
      if (!this.leaders) {
        return []
      }
      const rows = []
      for (let i = 0; i < 3; i++) {
        rows.push({
          byDistance: this.leaders.byDistance[i],
          byTime: this.leaders.byTime[i],
          byHeight: this.leaders.byHeight[i]
        })
      }
      return rows
    }
  }
}
</script>

<style>
  .table .member {
    word-break: break-word;
  }
</style>
